import LGCollectionTargetContainer from './Container'
import LGCollectionTargetsListContainer from './CollectionTargetsList'

export default {
    LGCollectionTargetContainer,
    LGCollectionTargetsListContainer
}